// extracted by mini-css-extract-plugin
export var problems = "problems-module--problems--2ef99";
export var problems__list = "problems-module--problems__list--bba02";
export var problems__listItem = "problems-module--problems__list-item--1af14";
export var problems__listText = "problems-module--problems__list-text--a9010";
export var problems__text = "problems-module--problems__text--8aa92";
export var problems__textOrange = "problems-module--problems__text-orange--e9336";
export var problems__undertext = "problems-module--problems__undertext--012d9";
export var video__content = "problems-module--video__content--74346";
export var video__content_iframe = "problems-module--video__content_iframe--fae76";
export var video__screencastWrapper = "problems-module--video__screencast-wrapper--e78f6";
export var video__text = "problems-module--video__text--8f5d9";